module.exports = __webpack_public_path__ + "static/img/image_error@3x.ec6d36f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/image_error@3x.png
// module id = 240
// module chunks = 18